import { Component, Inject, OnInit } from "@angular/core";
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { PismoUpdateStopDirectDebitFlagDialogData, PismoUpdateStopDirectDebitFlagDialogResult } from '@portal-workspace/grow-shared-library';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { RadioOptionsComponent } from '../radio-options-component/radio-options.component';
import { CurrencyInputComponent } from "../currency-selection-component/currency-input.component";
import { ApplicationDialogService, Mark, PortalHotToastService, doMarkAll, markTriggerSubject } from "@portal-workspace/grow-ui-library";
import { Subject, Subscription } from "rxjs";


@Component({
  templateUrl: './pismo-update-stop-direct-debit-flag.dialog.html',
  styleUrls: ['./pismo-update-stop-direct-debit-flag.dialog.scss'],
  standalone: true,
  imports: [
    FlexModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    LooseCurrencyPipe,
    RadioOptionsComponent,
    CurrencyInputComponent
]
})
export class PismoUpdateStopDirectDebitFlagDialog implements OnInit, Mark {

  formGroup: FormGroup<{
    reason: FormControl<string | null>,
  }>;
  formControlReason!: FormControl<string | null>;

  markTriggerSubject = markTriggerSubject;
  markObservable: Subject<boolean> = new Subject<boolean>();
  showCard: boolean = false;
  subscriptions: Subscription[] = [];

  accountId!: number;
  currentStopDirectDebit!: boolean;
  stopDirectDebit!: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PismoUpdateStopDirectDebitFlagDialogData,
    private dialogRef: MatDialogRef<PismoUpdateStopDirectDebitFlagDialog, PismoUpdateStopDirectDebitFlagDialogResult>,
    private formBuilder: FormBuilder,
    private toastService: PortalHotToastService,
    private dialogService: ApplicationDialogService,
  ) {
    this.accountId = data.accountId;
    this.currentStopDirectDebit = data.currentStopDirectDebit;
    this.formControlReason = formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      reason: this.formControlReason,
    });
  }

  mark() {
    this.formGroup.markAllAsTouched();
    this.markObservable.next(true);
  }

  ngOnInit(): void {
  }

  onCancel(event: Event) {
    this.dialogRef.close();
  }

  onSave(event: Event) {
    markTriggerSubject(this.formGroup).next(true);
    doMarkAll(this.formGroup);
    this.dialogRef.close({
      readyForSubmission: true,
      stopDirectDebit: !this.currentStopDirectDebit,
      accountId: this.accountId
    })
  }

}
